import myTheme from "../../../../../../lib/theme";
import { Head, Notes } from 'mdx-deck';
import OpeningSlide from "../../../../../../components/opening-slide";
import SlideHeadline from "../../../../../../components/slide-headline";
import Boids from "../../../../../../components/boids/Boids";
import Website from "../../../../../../components/website/Website";
import BackgroundImage from "../../../../../../components/background-image";
import OnBackground from "../../../../../../components/on-background";
import Impact from "../../../../../../components/impact";
import CustomSplit from "../../../../../../lib/split.layout";
import Center from "../../../../../../components/center";
import LargeImage from "../../../../../../components/largeImage";
import Credit from "../../../../../../components/credit";
import ClosingSlide from "../../../../../../components/closing-slide";
import BackgroundBubbles from "../../../../../../components/background-bubbles";
import Mastodon from "../../../../../../components/mastodon/Mastodon";
import WebM from "../../../../../../components/WebM";
import WebMInit from "../../../../../../components/WebMInit";
import WebsiteWithAdsImage from "../../../../../../img/ads.png";
import WMAnimatedImage from "../../../../../../img/wm-icon-animated.svg";
import IntersectionImage from "../../../../../../img/intersection.jpg";
import WiredProgressiveImage from "../../../../../../img/progressive.jpg";
import ActivityPubImage from "../../../../../../img/ActivityPub.png";
import MastodonLogoImage from "../../../../../../img/mastodon.png";
import TrainWaitingImage from "../../../../../../img/train-waiting.jpg";
import * as React from 'react';
export default {
  myTheme,
  Head,
  Notes,
  OpeningSlide,
  SlideHeadline,
  Boids,
  Website,
  BackgroundImage,
  OnBackground,
  Impact,
  CustomSplit,
  Center,
  LargeImage,
  Credit,
  ClosingSlide,
  BackgroundBubbles,
  Mastodon,
  WebM,
  WebMInit,
  WebsiteWithAdsImage,
  WMAnimatedImage,
  IntersectionImage,
  WiredProgressiveImage,
  ActivityPubImage,
  MastodonLogoImage,
  TrainWaitingImage,
  React
};